import React from "react";
import { useFormContext } from "react-hook-form";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import TaxGroup from "../../../../utilities/data/model/TaxGroup";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { StackScreenProps } from "@react-navigation/stack";
import colors from "react-native-ui-lib/src/style/colors";
import { Feather } from "@expo/vector-icons";
import {
  CreateProductRootParamList,
  EditProductRootParamList,
} from "../../../../types";
import { ProductFormValues } from "../../components/ProductForm/types";

export type ProductSelectTaxGroupScreenProps = StackScreenProps<
  CreateProductRootParamList & EditProductRootParamList,
  "ProductSelectTaxGroupScreen"
>;

export const ProductSelectTaxGroupScreen = ({
  navigation,
}: ProductSelectTaxGroupScreenProps) => {
  const database = useDatabase();

  const [taxGroups, setTaxGroups] = React.useState<TaxGroup[] | undefined>();

  const { watch, setValue } = useFormContext<ProductFormValues>();

  const watchedTaxGroupId = watch("taxGroupId");

  React.useEffect(() => {
    database
      .get<TaxGroup>("tax_groups")
      .query()
      .fetch()
      .then((l) => setTaxGroups(l));
  }, []);

  const handleOnSelect = React.useCallback((taxGroupId: string) => {
    setValue("taxGroupId", taxGroupId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  const items: FlatActionListItem[] = React.useMemo(() => {
    return (
      taxGroups?.map((taxGroup) => {
        return {
          key: taxGroup.id,
          title: taxGroup.name,
          onPress: () => handleOnSelect(taxGroup.id),
          disabled: watchedTaxGroupId == taxGroup.id,
          componentRight: (icon) => {
            return watchedTaxGroupId == taxGroup.id ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [taxGroups, watchedTaxGroupId, handleOnSelect]);

  return (
    <Page title="Select TaxGroup">
      <FlatActionList items={items} />
    </Page>
  );
};
